import { Component, OnInit } from '@angular/core';
import { OperationTypeService } from '../operation-type.service';
@Component({
  selector: 'app-operation-type',
  templateUrl: './operation-type.component.html',
  styleUrls: ['./operation-type.component.css'],
  providers: [OperationTypeService]
})
export class OperationTypeComponent implements OnInit {

  operationTypes: any =[];	

  constructor(private operationTypeService: OperationTypeService) { }

  ngOnInit() {

  	  this.operationTypeService.getContractorTypeList().subscribe(response=> {this.operationTypes=response['data'];});
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/operation_types/operation-type/operation-type.component.ts